import { IsNotEmpty, MinLength } from 'class-validator'

export class RejectLeaveRequest {
  @IsNotEmpty({ message: 'Enter a reason for rejection' })
  @MinLength(3, { message: 'Reason for rejection is too short' })
  public reason_for_rejection!: string

  constructor() {
    this.reason_for_rejection = ''
  }
}
